import {
  clearRegistrationUser,
  isRealization,
  isRealizationSubscribed,
} from "utils/fns";
import "../../style.scss";
import { useModal } from "context/ModalContext/Modal.context";
import { format } from "date-fns/format";
import { ptBR } from "date-fns/locale/pt-BR";
import { GrDownload } from "react-icons/gr";
import {
  ConcorrentesInfo,
  Realization,
  RealizationSubscribed,
} from "types/realization";
import { useAuth } from "context/AuthContext";
import { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa6";

import Spinner from "components/ui/Spinner";

interface Options {
  data: Realization | RealizationSubscribed;
  confirmedPlayerList?: any;
}

const ModalParticipants = ({ data, confirmedPlayerList }: Options) => {
  const { user } = useAuth();

  const [showListUser, setShowListUser] = useState(false);

  const { closeModal } = useModal();

  useEffect(() => {
    if (!!user) {
      if (
        isRealization(data) &&
        clearRegistrationUser(user?._id) === data.owner
      ) {
        setShowListUser(true);
      } else if (
        isRealizationSubscribed(data) &&
        clearRegistrationUser(user?._id) === data.player
      ) {
        setShowListUser(true);
      }
    }
  }, [user]);

  return (
    <div className="detail">
      <div className="tag">
        {data.category && <span>{String(data.category)}</span>}
      </div>
      <h2 className="mb-2 mt-3 text-lg font-medium font-bb text-black-bb">
        <strong>Realização: </strong>
        {isRealization(data) ? data.title : data.realization.title}
      </h2>
      <div className="p-4 bg-gray-bb-3">
        {isRealization(data) && (
          <>
            <h6 className="text-sm text-black-bb">
              <strong>Cadastrado por:</strong>
            </h6>
            <p>
              {data.owner_data.nome_guerra} ({data.owner_data.chave}), em{" "}
              {format(data.created, "dd 'de' MMMM 'de' yyyy", {
                locale: ptBR,
              })}
            </p>

            <h6 className="mt-2 text-sm text-black-bb">
              <strong>Detalhes da realização</strong>
            </h6>

            <p dangerouslySetInnerHTML={{ __html: data.description }} />

            <h6 className="mt-2 text-sm text-black-bb">
              <strong>Participantes</strong>
            </h6>
            {data.team_data.map((item) => (
              <p>
                {item.nome_guerra} ({item.chave})
              </p>
            ))}
          </>
        )}

        {isRealizationSubscribed(data) && (
          <>
            <p>
              <h6 className="text-sm text-black-bb">
                <strong>Cadastrado por:</strong>
              </h6>
              {data.realization.owner_data.nome_guerra} (
              {data.realization.owner_data.chave}), em{" "}
              {format(data.realization.created, "dd 'de' MMMM 'de' yyyy", {
                locale: ptBR,
              })}
            </p>

            {!!data.player_indication_data && (
              <>
                <p className="mt-2 mb-2 text-sm font-bold text-black-bb">
                  <strong>Inscrito por:</strong>
                </p>
                <p>
                  {data?.player_indication_data[0].nome_guerra} (
                  {data?.player_indication_data[0].chave})
                </p>
              </>
            )}

            <h6 className="mt-2 text-sm text-black-bb">
              <strong>Detalhes da realização</strong>
            </h6>

            <p
              dangerouslySetInnerHTML={{
                __html: data.realization.description,
              }}
            />

            {data.realization.team_data.length > 0 && (
              <>
                <h6 className="mt-2 text-sm text-black-bb">
                  <strong>
                    {`Participantes da realização (${
                      confirmedPlayerList?.confirmados.length || 0
                    } de
                    ${data.realization.team_data.length | 0} participantes
                    confirmados)`}
                  </strong>
                </h6>
                {data.realization.team_data.map((item) => (
                  <p
                    className={`${
                      confirmedPlayerList?.confirmados.includes(item.chave)
                        ? "text-green-bb"
                        : "pl-5"
                    }`}
                  >
                    {confirmedPlayerList?.confirmados.includes(item.chave) && (
                      <FaCheck className="inline mr-1" />
                    )}
                    {item.nome_guerra} ({item.chave})
                  </p>
                ))}
              </>
            )}

            {!!data.documento && data.documento.length > 0 ? (
              <>
                <p className="mt-2 mb-2 text-sm font-bold text-black-bb">
                  <strong>Documentação complementar da realização</strong>
                </p>
                {data.documento.map((item) => (
                  <>
                    {!!item && item !== null && (
                      <>
                        {item.type === "video" ? (
                          <div className="relative mt-6">
                            <div className="flex items-start justify-center w-full">
                              <div className="absolute flex flex-col top-2/4 translate-y-[-50%]">
                                <Spinner />
                              </div>
                            </div>
                            <div className="mt-6">
                              <a
                                href={item.file}
                                className="mt-4 px-4 py-2 text-white bg-blue-500 rounded hover:bg-blue-700"
                                target="_blank"
                                rel="noreferrer"
                              >
                                Ver vídeo
                              </a>
                            </div>
                          </div>
                        ) : (
                          <div className="mt-6">
                            <button
                              className="rounded-[4px] py-[14px] px-5 bg-gray-bb-2 text-white-bb-1 uppercase flex items-center gap-2 font-bold"
                              onClick={() => {
                                window.open(item.file, "_blank");
                              }}
                            >
                              <GrDownload size={22} />
                              Download
                            </button>
                          </div>
                        )}
                      </>
                    )}
                  </>
                ))}
              </>
            ) : (
              <></>
            )}
          </>
        )}
      </div>

      <div className="flex items-center justify-center">
        <button
          className="px-4 py-3 font-bold uppercase text-blue-bb"
          onClick={closeModal}
        >
          Fechar
        </button>
      </div>
    </div>
  );
};

export default ModalParticipants;
